import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetPaymentMethodsCheckoutUseCase extends UseCase {
  constructor({repository, getPaymentMethodsCheckoutError}) {
    super()
    this._repository = repository
    this._getPaymentMethodsCheckoutError = getPaymentMethodsCheckoutError
  }

  /**
   * @param {String} orderId order identifier
   * @param {String} testCode force an adyen purchase response
   * @return {Promise<Object, Error>}
   */
  execute = async ({orderId, testCode}) => {
    const paymentMethods = await this._repository.getPaymentMethods({
      orderId,
      testCode
    })
    return paymentMethods.toJSON()
  }
}
